<template>
  <div id="statement-screen">
    <div class="col-sm-5">
      <base-textarea
        :labelValue="$t(`app.statements.attributes.statement`)"
        :labelClassNames="'control-label mb-10 text-left'"
        v-model="model.statement"
        ref="messageField"
        :maxLength="500"
        classes="form-input"
      />
        <div class="form-input">
          <label class="control-label mb-10 text-left">{{ $t('app.statements.attributes.locations')}}</label>
          <multiselect v-model="model.location"
            :options="locationList"
            :multiple="false"
            :selectLabel="$t('app.multiselect.select')"
            :selectedLabel="$t('app.multiselect.selected')"
            :deselectLabel="$t('app.multiselect.remove')"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :placeholder="$t(`app.inspections.attributes_placeholders.location_ids`)"
            label="name"
            track-by="id"
            :preselect-first="false"
            @input="locationsChanged">
            <span slot="noOptions">{{$t('app.generals.empty_list')}}</span>
            <template #noResult>
              {{$t('app.generals.empty_list')}}
            </template>
          </multiselect>
        </div>
      <base-dropdown
        :list="frequencyList"
        v-model="model.control_frequency"
        :defaultValue="model.control_frequency"
        labelClassNames="control-label mt-10 mb-10 text-left"
        :labelValue="$t('app.statements.attributes.control_frequency')"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";
import BaseDropdown from "@/components/shared/inputs/BaseDropDown";
import FormInput from "@/components/shared/inputs/FormInput";
import BaseTextarea from "@/components/shared/inputs/BaseTextArea";

export default {
  name: "StatementScreen",
  components: {
    "base-dropdown": BaseDropdown,
    "form-input": FormInput,
    "base-textarea": BaseTextarea,
    "vue-tags-input": VueTagsInput
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      frequencyList: [
        {
          text: this.$t("app.statements.frequencies.1"),
          value: 1
        },
        {
          text: this.$t("app.statements.frequencies.4"),
          value: 4
        },
        {
          text: this.$t("app.statements.frequencies.13"),
          value: 13
        },
        {
          text: this.$t("app.statements.frequencies.26"),
          value: 26
        },
        {
          text: this.$t("app.statements.frequencies.52"),
          value: 52
        }
      ],
      locations: []
    };
  },
  computed: {
    ...mapGetters({
      commonData: "partners/commonData"
    }),
    locationList() {
      return this.locations.map(function(location) {
        return {
          id: location.id,
          name: location.name
        };
      });
    }
  },
  created() {
    this.fetchCommonData(this.commonData.partner.id)
  },
  mounted() {

  },
  methods: {
    ...mapActions({
      fetchCommonData: "partners/fetchCommonData"
    }),
    filteredList(list, tag) {
      if (list) {
        return list.filter(i => {
          return i.text.toLowerCase().indexOf(tag.toLowerCase()) !== -1;
        });
      }
    },
    locationsChanged(locations) {
      let locArray = []
      locArray.push(locations)
      this.model.locations = locArray;
    },
    refreshStatement(location) {
      this.locations = location.map(location => {
        return { id: location.id, name: location.name };
      });
    }
  },
  watch: {}
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.locations {
  max-width: 100% !important;
  margin-bottom: 20px;
  &.vue-tags-input {
    height: auto !important;
  }
  & /deep/ .ti-input {
    border: none !important;
    input[type="text"] {
      font-family: 'Roboto', sans-serif !important;
    }
  }
  & /deep/ .ti-tag {
    background-color: var(--main-color) !important;
    .ti-tag-center {
      font-family: 'Roboto', sans-serif !important;
    }
  }
  & /deep/ .ti-deletion-mark {
    background-color: #ee234f !important;
  }
  & /deep/ .ti-tag:before {
    display: none !important;
  }

}

 /deep/ .multiselect__tag {
    background: var(--main-color);
  }

  /deep/ .multiselect__tag-icon:hover {
    background: var(--main-color);
  }

  /deep/ .multiselect__tag-icon:after {
    color: #000;
  }

 /deep/ .multiselect__option--highlight:after {
    background: none;
  }

  /deep/ .multiselect__option--selected.multiselect__option--highlight:after {
    background: none;
  }

  /deep/ .multiselect__option--selected.multiselect__option--highlight {
      background: #ff282873 !important;
  }

  /deep/ .multiselect__option--highlight {
    background: #ff61289f;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/StatementScreen.vue